import React from 'react';

import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import Button from "components/Button";
import { DeclarationSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete,
  includeDeclaration,
  setIncludeDeclaration,
  handleEditWording,
}) {
  return (
    <>
      <FormSection
        disableAll={disableAll}
        sectionName='DECLARATION'
        formikRef={formikRef}
        questionnaire={globalQuestionnaire}
        setQuestionnaire={setGlobalQuestionnaire}
        values={formikProps.values}
        error={formikProps.errors}
        setFieldValue={formikProps.setFieldValue}
        setFieldError={formikProps.setFieldError}
        idOperation={idOperation}
        idOperationParent={idOperationParent}
        onQuestionChange={(question, value, setFieldValue, questionnaireUpdated) =>
          DeclarationSection.events.handleQuestionChange({
            question,
            value,
            questionnaireUpdated,
            setQuestionnaire: setGlobalQuestionnaire,
            setFieldValue,
            setIncludeDeclaration,
            questionnaireAnswersToDelete,
            setQuestionnaireAnswersToDelete,
            documentsToDelete,
            setDocumentsToDelete
          })
        }
      />
      {includeDeclaration && (
        <Button
          disabled={disableAll}
          primary
          style={{ marginLeft: "10px", marginTop: "5px" }}
          onClick={() => {
            handleEditWording();
          }}
        >
          EDIT DECLARATION
        </Button>
      )}
    </>
  )
}

const components = {
  RenderSection
}

export { components }